import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { Image } from 'components/core/Image';

import './imageNotAvailable.scss';

export default function ImageNotAvailable({
	children, className, size = 'small', color = 'black', imageText = 'Image not available', defaultImage
}) {
	return (
		<div className={classnames('image-not-available', className)}>
			{defaultImage &&
				<Image
					flexImage
					src={defaultImage}
					alt="image coming soon"
				/>
			}
			<Text className="text-container" strong size={size} color={color}>
				{children || imageText}
			</Text>
		</div>
	);
}

ImageNotAvailable.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	size: PropTypes.string,
	color: PropTypes.string,
	imageText: PropTypes.node,
	defaultImage: PropTypes.string
};

